import type { DriveStep } from 'driver.js'

export const adminTourSteps: DriveStep[] = [
  {
    element: '[data-tour="sidebar-dashboard"]',
    popover: {
      title: 'Your Command Center',
      description: 'Real-time overview of sessions, revenue, and facility activity — all in one place.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="sidebar-schedule"]',
    popover: {
      title: 'Schedule & Calendar',
      description: 'Manage bookings, view daily and weekly schedules, and keep your facility running smoothly.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="sidebar-classes"]',
    popover: {
      title: 'Classes & Camps',
      description: 'Set up recurring classes, seasonal camps, manage rosters, and track attendance.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="sidebar-members"]',
    popover: {
      title: 'Client Management',
      description: 'Full client profiles with attendance history, packages, waivers, and communication logs.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="sidebar-finance"]',
    popover: {
      title: 'Finance & Billing',
      description: 'Payments, invoices, and revenue trends — get a clear picture of your business health.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="sidebar-coach-studio"]',
    popover: {
      title: 'Coach Studio',
      description: 'Record training sessions, annotate video, and share clips with athletes and parents.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="sidebar-assistant"]',
    popover: {
      title: 'Aria — AI Receptionist',
      description: 'Your 24/7 virtual receptionist that answers calls, books sessions, and handles inquiries.',
      side: 'right',
      align: 'start',
    },
  },
]

export const customerTourSteps: DriveStep[] = [
  {
    element: '[data-tour="customer-dashboard"]',
    popover: {
      title: 'Your Dashboard',
      description: 'See upcoming sessions, recent activity, and quick actions all in one place.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="customer-schedule"]',
    popover: {
      title: 'My Schedule',
      description: 'View and manage your bookings, reschedule sessions, and check availability.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="customer-profile"]',
    popover: {
      title: 'Your Profile',
      description: 'Update your info, view training history, and manage your account details.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="customer-store"]',
    popover: {
      title: 'Store',
      description: 'Browse and purchase training packages, memberships, and gear.',
      side: 'right',
      align: 'start',
    },
  },
]
